import React, { useEffect, useState, useRef } from 'react';
import Handlebars from 'handlebars/dist/cjs/handlebars';
import * as templateSettingsApi from '../../api/templateSettingsApi';
import { TemplateStrings as Strings } from '../../utils/config';
import { registerHandlebarsHelpers } from '../../utils/handlebarsHelpers';
import Spinner from '../common/Spinner';
import TemplatePreviewPopUp from '../PopUp/TemplatePreviewPopUp';
import ScalablePreview from '../ScalablePreview/ScalablePreview';

const TemplatePreview = ({ templateId, previewContent }) => {
    const [previewData, setPreviewData] = useState('');
    const [compiledTemplate, setCompiledTemplate] = useState('');
    const [loading, setLoading] = useState(true);
    const [showPopUp, setShowPopUp] = useState(false);
    const [previewToggle, _setPreviewToggle] = useState(false);

    // Ref used to toggle the preview by event listener
    const previewToggleRef = useRef(previewToggle)

    // Ref needs to be updated along with the state
    const setPreviewToggle = value => {
        previewToggleRef.current = value;
        _setPreviewToggle(value);
    }

    // Add admin panel collapse listener on element mount
    useEffect(() => {
        function updatePreview() {
            setPreviewToggle(!previewToggleRef.current)
        }

        document.querySelector('.can-ui-admin-panel__toggle').addEventListener('click', updatePreview);
        return () => {
            document.querySelector('.can-ui-admin-panel__toggle').removeEventListener('click', updatePreview);
        };
    }, [])

    useEffect(() => {
        setLoading(true);
        const fetchPreviewData = async () => {
            const data = await templateSettingsApi.getTemplatePreviewData(templateId);
            setPreviewData(data);
        }
        setTimeout(() => setLoading(false), 750);
        fetchPreviewData();

    }, [templateId])

    useEffect(() => {
        if (previewData && previewContent) {
            registerHandlebarsHelpers();

            const envelopedTemplate = envelopTemplate(previewContent);
            var template = Handlebars.compile(envelopedTemplate);
            var parseData = JSON.parse(previewData);
            setCompiledTemplate(template(parseData));
        } else {
            setCompiledTemplate('');
        }
    }, [previewData, previewContent])

    const togglePopUp = () => {
        setShowPopUp(!showPopUp);
        setPreviewToggle(!previewToggle);
    }

    const handleClick = () => {
        compiledTemplate && togglePopUp();
    }

    return (
        <div>
            {
                loading ?
                    <Spinner />
                    : <div className="td-template-preview" onClick={handleClick}>
                        <span>{compiledTemplate && Strings.expandPreview}</span>
                        <ScalablePreview htmlToDisplay={compiledTemplate || Strings.noPreviewData} toggleRefresh={previewToggle} />
                        <TemplatePreviewPopUp show={showPopUp} compiledTemplate={compiledTemplate} togglePopUp={togglePopUp} />
                    </div>
            }
        </div>
    );
}

export default TemplatePreview;

function envelopTemplate(template) {
    return "{{#each models}}" + template + "{{/each}}"
}
